import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import {consumeContext} from "../../../../../../../../react/context";
import "./routes-section.scss";
import {RoutesTable} from "./routes-table/routes-table";
import {ErrorHighlighter} from "../../../../../../../light/error-highlighter";
import {cx} from "emotion";
import {scrollIntoView} from "../../../../../../../light/scroll-into-view";
import {Static2} from "../../../../../../../../react/static-2";

export const RoutesSection = ({allRoutes, next}) => cs(
    consumeContext("company"),
    ["routesTable", ({}, next) => RoutesTable({allRoutes, next})],
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ({company, routesTable, domRef, eh}) => next({
        valid: routesTable?.valid,
        getSubmitData: routesTable.getSubmitData,
        getSelecteds: routesTable.getSelecteds,
        totalCount: routesTable.totalCount,
        selectedCount: routesTable.selectedCount,
        highlightErrors: () => {
            eh.start();
            scrollIntoView(domRef.get());
        },
        reset: routesTable.reset,
        setUnselecteds: routesTable.setUnselecteds,
        render: ({showErrors}) => (
            <div className="routes-section-0nu">

                <div className="header">
                    <div className="left">
                        <div className="title" xd-qa-type="label" xd-qa-name="Neighborhood Search Routes Table Title">
                            Review Selected Neighborhoods
                        </div>
                        <div className="sub-title" xd-qa-type="label" xd-qa-name="Neighborhood Search Routes Table Description">
                            Check/Uncheck Rows to Add/Remove Neighborhood Routes
                        </div>
                    </div>
                    <div className="right">
                        {routesTable.renderSearch()}
                    </div>
                </div>

                <div className={cx("box", eh.css)} ref={domRef.set}>
                    {routesTable.renderTable()}
                    
                    {Instruction({})}
                </div>
            </div>
        ),
    }),
);

const Instruction = ({}) => (
    <div className="instruction" xd-qa-type="label" xd-qa-name="Neighborhood Search Routes Table Instruction">
        The list may not be copied, duplicated, or transferred. The list may not be used for building or integrating{" "}
        into any other databases. Altering the data may effect your postage rates.
    </div>
);




